import React, { PureComponent, PropTypes } from 'react';
import TextareaAutosize from 'react-autosize-textarea';

import './TextAreaItem.css';

const MAX_TRAVEL_REASON_LENGTH = 255;

export default class TextAreaItem extends PureComponent {
    static propTypes = {
        value: PropTypes.string,
        setValue: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        const value = e.target.value;
        const length = value.length;

        if (length > MAX_TRAVEL_REASON_LENGTH)
            return false;

        this.props.setValue(value === `` ? null : value);
    }

    render() {
        const value = this.props.value === null ? `` : this.props.value;

        return (
            <TextareaAutosize
                value={value}
                placeholder="Other"
                onChange={this.onChange}
                rows={1}
                maxRows={3}
            ></TextareaAutosize>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/SelectList/TextAreaItem.jsx